import GeneralSettingsForm from './GeneralSettingsForm';
import ScrollSection from 'components/ScrollSection';

const StaffDirectory = () => {
  return (
    <ScrollSection>
      <GeneralSettingsForm />
    </ScrollSection>
  );
};

export default StaffDirectory;
